/** Section keys aligned with backend seed (home_sections.section_key). */
export const HOME_SECTION_KEYS = {
  STORIES_CAROUSEL: "stories_carousel",
  HERO_BANNER: "hero_banner",
  GAME_SEARCH_BAR: "game_search_bar",
  CATEGORY_PILLS: "category_pills",
  HOME_SEARCH_RESULTS: "home_search_results",
  BREAKING_LEAGUE: "breaking_league",
  TOP_GAMES: "top_games",
  CUSTOM_BOARDS_GROUP: "custom_boards_group",
  MINI_GAMES_CAROUSEL: "mini_games_carousel",
  TOP_PAYING_GAMES: "top_paying_games",
  FAVORITE_GAMES_CAROUSEL: "favorite_games_carousel",
  RECENTLY_PLAYED_GAMES: "recently_played_games",
  LOTTERY_GAMES_CAROUSEL: "lottery_games_carousel",
  ANIMALITOS_EXPRESS_CAROUSEL: "animalitos_express_carousel",
  LIVE_GAMES: "live_games",
  GAME_PROMOS: "game_promos",
  CUSTOM_CAROUSELS_GROUP: "custom_carousels_group",
  RECENT_GAMES: "recent_games",
  THEMES_CAROUSEL: "themes_carousel",
  HOME_NEWS_CAROUSEL: "home_news_carousel",
  HOME_STATS_GRID: "home_stats_grid",
  PROMO_ROW: "promo_row",
};

/** Default Home block order (matches legacy hardcoded layout). */
export const DEFAULT_HOME_SECTION_ORDER = [
  HOME_SECTION_KEYS.STORIES_CAROUSEL,
  HOME_SECTION_KEYS.HERO_BANNER,
  HOME_SECTION_KEYS.GAME_SEARCH_BAR,
  HOME_SECTION_KEYS.CATEGORY_PILLS,
  HOME_SECTION_KEYS.HOME_SEARCH_RESULTS,
  HOME_SECTION_KEYS.BREAKING_LEAGUE,
  HOME_SECTION_KEYS.TOP_GAMES,
  HOME_SECTION_KEYS.CUSTOM_BOARDS_GROUP,
  HOME_SECTION_KEYS.MINI_GAMES_CAROUSEL,
  HOME_SECTION_KEYS.TOP_PAYING_GAMES,
  HOME_SECTION_KEYS.FAVORITE_GAMES_CAROUSEL,
  HOME_SECTION_KEYS.RECENTLY_PLAYED_GAMES,
  HOME_SECTION_KEYS.LOTTERY_GAMES_CAROUSEL,
  HOME_SECTION_KEYS.ANIMALITOS_EXPRESS_CAROUSEL,
  HOME_SECTION_KEYS.LIVE_GAMES,
  HOME_SECTION_KEYS.GAME_PROMOS,
  HOME_SECTION_KEYS.CUSTOM_CAROUSELS_GROUP,
  HOME_SECTION_KEYS.RECENT_GAMES,
  HOME_SECTION_KEYS.THEMES_CAROUSEL,
  HOME_SECTION_KEYS.HOME_NEWS_CAROUSEL,
  HOME_SECTION_KEYS.HOME_STATS_GRID,
  HOME_SECTION_KEYS.PROMO_ROW,
];
